import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import * as Icon from 'react-bootstrap-icons';

export default function Home() {
  return (
    <>
    <div className='hero-div'>
        <div className='inner'>
            <p className='body-text brand-color fs-3 fw-bold'>Your favourite bakery in town!</p>
            <p className='brand-text brand-color fs-1'>Anne's Bakery</p>
        </div>
    </div>
    <div className='container small-device'>
        <p className='d-flex justify-content-center brand-color fw-bold fs-4 py-4'>Our Products</p>
        <Row className='pb-3'>
            <Col>
                <img src='./images/1.webp' className='product' alt='product1'></img>
            </Col>
            <Col>
                <img src='./images/2.png' className='product' alt='product2'></img>
            </Col>
            <Col>
                <img src='./images/3.webp' className='product' alt='product3'></img>
            </Col>
            <Col>
                <img src='./images/4.jpg' className='product' alt='product4'></img>
            </Col>
        </Row>
        <Row className='pb-3'>
            <Col>
                <img src='./images/5.jpg' className='product' alt='product5'></img>
            </Col>
            <Col>
                <img src='./images/6.jpg' className='product' alt='product6'></img>
            </Col>
            <Col>
                <img src='./images/7.jpg' className='product' alt='product7'></img>
            </Col>
            <Col>
                <img src='./images/8.jpg' className='product' alt='product8'></img>
            </Col>
        </Row>    
        <div className='py-4 d-grid gap-2 d-md-flex justify-content-md-center'>
            <button type='button' className='btn login'>Submit</button>
        </div>
        <div className='home-details lght mb-3'>
            <div className='small-inner inner'>
                <p>Baking refers to a form of cooking that involves prolonged
                    heating. Bakers usually use flour and eggs to bake. However,
                    you can replace these baking ingredients with gluten-free
                    alternatives.
                </p>
                <p>
                    In addition, baking involves an oven. However,
                    you can use other cooking methods to make treats without an
                    oven. These methods include steaming and deep-frying. When
                    people think of baking, bread usually comes to mind. But
                    baking doesn't just equate to bread. Other popular baked
                    goods include cookies, cakes, muffins, and cupcakes.
                </p>
            </div>
        </div>
        
        <Row className='my-5 text-center'>
            <Col>
                <div class="card">
                    <div class="card-body">
                        <Icon.PersonCircle className='review-image' />
                        <h5 class="card-title">Sakinah Sahir</h5>
                        <Icon.StarFill /><Icon.StarFill /><Icon.StarFill /><Icon.StarFill /><Icon.StarFill />
                        <p class="card-text mt-3">                            
                            I ordered for pickup and the breads were prepared still
                            fresh. I'm very satisfied with the service
                        </p>
                    </div>
                </div>
            </Col>
            <Col>
                <div class="card">
                    <div class="card-body">
                        <Icon.PersonCircle className='review-image' />
                        <h5 class="card-title">Sakinah Sahir</h5>
                        <Icon.StarFill /><Icon.StarFill /><Icon.StarFill /><Icon.StarFill /><Icon.StarFill />
                        <p class="card-text mt-3">                            
                            I ordered for pickup and the breads were prepared still
                            fresh. I'm very satisfied with the service
                        </p>
                    </div>
                </div>
            </Col>
            <Col>
                <div class="card">
                    <div class="card-body">
                        <Icon.PersonCircle className='review-image' />
                        <h5 class="card-title">Sakinah Sahir</h5>
                        <Icon.StarFill /><Icon.StarFill /><Icon.StarFill /><Icon.StarFill /><Icon.StarFill />
                        <p class="card-text mt-3">                            
                            I ordered for pickup and the breads were prepared still
                            fresh. I'm very satisfied with the service
                        </p>
                    </div>
                </div>
            </Col>
        </Row>

    </div>
    </>
  );
}